(function () {
  'use strict';

  var CATEGORY_ORDER = ['main', 'breakfast', 'dessert'];
  // Additional builder recipes are not Shopify listings. Keep the public eligibility gate intact.
  var ADDITIONAL_RECIPE_IDS = Object.freeze(['scrambled-egg', 'custard-apple-crunch', 'chocolate-mousse', 'salmon-broccoli-pasta', 'chicken-tikka']);

  var LEGACY_PACK_IDS = Object.freeze({
    'essential-3': 'vegetarian-3',
    'essential-6': 'main-meals-6',
    'essential-12': 'main-meals-12',
    'essential-24': 'main-meals-24',
    'balanced-6': 'breakfast-main-6',
    'balanced-12': 'breakfast-main-12',
    'balanced-24': 'breakfast-main-24',
    'deluxe-12': 'breakfast-main-12',
    'deluxe-24': 'breakfast-main-24'
  });

  // These two supplied-code/specification questions remain open; verified extras do not inherit them.
  function requiresRecipeConfirmation(id) { return id === 'custard-apple-crunch' || id === 'chocolate-mousse'; }
  var FEATURED_IDS = ["main-meals-3","breakfast-main-6","vegetarian-3"];
  var SECONDARY_IDS = ["main-meals-6","main-meals-12","main-meals-24","breakfast-main-12","breakfast-main-24","breakfast-main-pudding-4","breakfast-main-pudding-10","breakfast-main-pudding-18","breakfast-two-main-pudding-5","breakfast-two-main-pudding-14","breakfast-two-main-pudding-26"];
  var EXPECTED_FAMILY_IDS = {
  "main-meals": [
    "main-meals-3",
    "main-meals-6",
    "main-meals-12",
    "main-meals-24"
  ],
  "breakfast-main": [
    "breakfast-main-6",
    "breakfast-main-12",
    "breakfast-main-24"
  ],
  "breakfast-main-pudding": [
    "breakfast-main-pudding-4",
    "breakfast-main-pudding-10",
    "breakfast-main-pudding-18"
  ],
  "breakfast-two-main-pudding": [
    "breakfast-two-main-pudding-5",
    "breakfast-two-main-pudding-14",
    "breakfast-two-main-pudding-26"
  ],
  "vegetarian": [
    "vegetarian-3"
  ]
};
  var FROZEN_RULE_SIGNATURE = '1.9.36|3|6|1|999|200000|40';
  var FROZEN_FAMILY_SIGNATURES = Object.freeze([
  "main-meals|Main Meals|A varied selection of main meals, including meat, fish and vegetarian recipes across the range.",
  "breakfast-main|Breakfast & Main Meals|Breakfasts and main meals for your food reserve, with puddings included as extras.",
  "breakfast-main-pudding|Breakfast, main + pudding|Breakfast, a main meal and Rice Pudding with Strawberry in each daily serving pattern.",
  "breakfast-two-main-pudding|Breakfast, 2 mains + pudding|Breakfast, two main meals and Rice Pudding with Strawberry in each daily serving pattern.",
  "vegetarian|Vegetarian Main Meals|A vegetarian selection of cheese pasta, beans and vegetable chilli."
]);
  var FROZEN_RECIPE_SIGNATURES = Object.freeze([
    'macaroni-cheese|Macaroni Cheese|main|31900|true|macaroni-cheese-6-tins|macaroni_image|844300',
    'vegetable-tikka|Vegetable Tikka with Rice|main|30900|false|-|-|868300',
    'vegetable-chilli|Vegetable Chilli with Rice|main|30900|true|vegetable-chipotle-chilli-with-rice-6-tins|vegetable_image|845300',
    'vegetable-fried-rice|Vegetable Fried Rice|main|30900|false|-|-|862300',
    'five-bean-cassoulet|Five Bean Cassoulet|main|30900|true|5-bean-cassoulet-6-tins|cassoulet_image|898300',
    'spicy-pasta-arabiata|Spicy Pasta Arrabbiata|main|30900|true|spicy-pasta-arrabiata-box-of-6-tins|spicy_image|899300',
    'chilli-con-carne|Chilli Con Carne with Rice|main|35900|true|chilli-con-carne-with-rice-6-tins|chilli_image|860300',
    'salmon-broccoli-pasta|Salmon and Broccoli Pasta|main|34900|false|-|-|846300',
    'chicken-tikka|Chicken Tikka with Rice|main|36900|false|-|-|841300',
    'chicken-fajita|Chicken Fajita with Rice|main|36900|true|chicken-fajita-with-rice-6-tins|chicken_image|842300',
    'chicken-fried-rice|Chicken Fried Rice|main|36900|false|-|-|847300',
    'sweet-sour-chicken|Sweet and Sour Chicken with Rice|main|36900|false|-|-|861300',
    'pasta-bolognaise|Pasta Bolognaise|main|38900|true|pasta-bolognaise-6-tins|pasta_image|840300',
    'beef-potato-stew|Beef and Potato Stew|main|38900|false|-|-|843300',
    'scrambled-egg-cheese|Scrambled Egg with Cheese|breakfast|34900|true|scrambled-egg-with-cheese-6-tins|scrambled_image|848300',
    'scrambled-egg|Scrambled Egg|breakfast|34900|false|-|-|856300',
    'morning-oats|Morning Oats with Raspberry|breakfast|29900|true|morning-oats-with-raspberry-6-tins|oats_image|849300',
    'custard-apple-crunch|Custard Apple Crunch|dessert|28900|false|-|-|852300',
    'chocolate-mousse|Chocolate Mousse with Granola and Cherry|dessert|29900|false|-|-|851300',
    'rice-pudding|Rice Pudding with Strawberry|dessert|28900|true|rice-pudding-with-strawberries-6-tins|rice_image|830300'
  ]);
  var FROZEN_READY_MADE_SIGNATURES = Object.freeze([
  "main-meals-3|main-meals|Main Meals 18 tins|A varied selection of main meals, including meat, fish and vegetarian recipes across the range.|3|18|104700|104700|0|0|enquiry|true|chilli-con-carne:1,chicken-fajita:1,macaroni-cheese:1",
  "main-meals-6|main-meals|Main Meals 36 tins|A varied selection of main meals, including meat, fish and vegetarian recipes across the range.|6|36|209400|209400|0|0|quote|false|chilli-con-carne:1,chicken-fajita:1,macaroni-cheese:1,pasta-bolognaise:1,spicy-pasta-arabiata:1,salmon-broccoli-pasta:1",
  "main-meals-12|main-meals|Main Meals 72 tins|A varied selection of main meals, including meat, fish and vegetarian recipes across the range.|12|72|414800|414800|0|0|quote|false|macaroni-cheese:2,chilli-con-carne:2,chicken-fajita:1,chicken-tikka:1,pasta-bolognaise:2,spicy-pasta-arabiata:1,salmon-broccoli-pasta:1,vegetable-chilli:1,five-bean-cassoulet:1",
  "main-meals-24|main-meals|Main Meals 144 tins|A varied selection of main meals, including meat, fish and vegetarian recipes across the range.|24|144|829600|829600|0|0|quote|false|macaroni-cheese:4,chilli-con-carne:4,chicken-fajita:2,chicken-tikka:2,pasta-bolognaise:4,spicy-pasta-arabiata:2,salmon-broccoli-pasta:2,vegetable-chilli:2,five-bean-cassoulet:2",
  "breakfast-main-6|breakfast-main|Breakfast & Main Meals 36 tins|Breakfasts and main meals for your food reserve, with puddings included as extras.|6|36|198400|198400|0|0|enquiry|true|morning-oats:1,scrambled-egg-cheese:1,chilli-con-carne:1,chicken-fajita:1,macaroni-cheese:1,rice-pudding:1",
  "breakfast-main-12|breakfast-main|Breakfast & Main Meals 72 tins|Breakfasts and main meals for your food reserve, with puddings included as extras.|12|72|398800|398800|0|0|quote|false|morning-oats:2,scrambled-egg-cheese:1,scrambled-egg:1,macaroni-cheese:1,chilli-con-carne:1,chicken-fajita:1,pasta-bolognaise:1,salmon-broccoli-pasta:1,spicy-pasta-arabiata:1,vegetable-chilli:1,rice-pudding:1",
  "breakfast-main-24|breakfast-main|Breakfast & Main Meals 144 tins|Breakfasts and main meals for your food reserve, with puddings included as extras.|24|144|797600|797600|0|0|quote|false|morning-oats:5,scrambled-egg-cheese:2,scrambled-egg:2,macaroni-cheese:2,chilli-con-carne:2,chicken-fajita:2,pasta-bolognaise:2,salmon-broccoli-pasta:2,vegetable-chilli:1,five-bean-cassoulet:1,spicy-pasta-arabiata:1,rice-pudding:1,chocolate-mousse:1",
  "vegetarian-3|vegetarian|Vegetarian Main Meals 18 tins|A vegetarian selection of cheese pasta, beans and vegetable chilli.|3|18|93700|93700|0|0|enquiry|true|macaroni-cheese:1,five-bean-cassoulet:1,vegetable-chilli:1",
  "breakfast-main-pudding-4|breakfast-main-pudding|Breakfast, main + pudding 24 tins|Breakfast, a main meal and Rice Pudding with Strawberry in each daily serving pattern.|4|24|131600|131600|0|0|enquiry|false|morning-oats:1,chicken-fajita:1,chilli-con-carne:1,rice-pudding:1",
  "breakfast-main-pudding-10|breakfast-main-pudding|Breakfast, main + pudding 60 tins|Breakfast, a main meal and Rice Pudding with Strawberry in each daily serving pattern.|10|60|325000|325000|0|0|quote|false|morning-oats:2,scrambled-egg-cheese:1,chicken-fajita:1,chilli-con-carne:1,macaroni-cheese:1,pasta-bolognaise:1,rice-pudding:3",
  "breakfast-main-pudding-18|breakfast-main-pudding|Breakfast, main + pudding 108 tins|Breakfast, a main meal and Rice Pudding with Strawberry in each daily serving pattern.|18|108|577200|577200|0|0|quote|false|morning-oats:3,scrambled-egg-cheese:2,chicken-fajita:2,chilli-con-carne:1,macaroni-cheese:1,pasta-bolognaise:1,spicy-pasta-arabiata:1,vegetable-chilli:1,five-bean-cassoulet:1,rice-pudding:5",
  "breakfast-two-main-pudding-5|breakfast-two-main-pudding|Breakfast, 2 mains + pudding 30 tins|Breakfast, two main meals and Rice Pudding with Strawberry in each daily serving pattern.|5|30|163500|163500|0|0|enquiry|false|morning-oats:1,chicken-fajita:1,chilli-con-carne:1,macaroni-cheese:1,rice-pudding:1",
  "breakfast-two-main-pudding-14|breakfast-two-main-pudding|Breakfast, 2 mains + pudding 84 tins|Breakfast, two main meals and Rice Pudding with Strawberry in each daily serving pattern.|14|84|454600|454600|0|0|quote|false|morning-oats:2,scrambled-egg-cheese:1,chicken-fajita:2,chilli-con-carne:1,macaroni-cheese:1,pasta-bolognaise:1,spicy-pasta-arabiata:1,vegetable-chilli:1,five-bean-cassoulet:1,rice-pudding:3",
  "breakfast-two-main-pudding-26|breakfast-two-main-pudding|Breakfast, 2 mains + pudding 156 tins|Breakfast, two main meals and Rice Pudding with Strawberry in each daily serving pattern.|26|156|849400|849400|0|0|quote|false|morning-oats:3,scrambled-egg-cheese:2,chicken-fajita:3,chilli-con-carne:3,macaroni-cheese:2,pasta-bolognaise:2,spicy-pasta-arabiata:2,vegetable-chilli:2,five-bean-cassoulet:2,rice-pudding:5"
]);

  var PLANNER_PERIODS = Object.freeze({
    '2-weeks': Object.freeze({ id: '2-weeks', label: '2 weeks', days: 14, token: '2w' }),
    '1-month': Object.freeze({ id: '1-month', label: '1 month', days: 30, token: '1m' }),
    '3-months': Object.freeze({ id: '3-months', label: '3 months', days: 90, token: '3m' }),
    '6-months': Object.freeze({ id: '6-months', label: '6 months', days: 180, token: '6m' }),
    '12-months': Object.freeze({ id: '12-months', label: '12 months', days: 365, token: '12m' })
  });
  var PLANNER_PATTERNS = Object.freeze({
    'one-main': Object.freeze({ id: 'one-main', label: 'One main-meal occasion', token: 'main', breakfast: 0, main: 1, pudding: 0 }),
    'breakfast-main': Object.freeze({ id: 'breakfast-main', label: 'One breakfast and one main-meal occasion', token: 'bm', breakfast: 1, main: 1, pudding: 0 }),
    'breakfast-main-pudding': Object.freeze({ id: 'breakfast-main-pudding', label: 'One breakfast, one main-meal and one pudding occasion', token: 'bmp', breakfast: 1, main: 1, pudding: 1 }),
    'breakfast-two-main-pudding': Object.freeze({ id: 'breakfast-two-main-pudding', label: 'One breakfast, two main-meal and one pudding occasion', token: 'b2mp', breakfast: 1, main: 2, pudding: 1 })
  });
  var PLANNER_PERIOD_ORDER = Object.freeze(['2-weeks', '1-month', '3-months', '6-months', '12-months']);
  var PLANNER_PATTERN_ORDER = Object.freeze(['one-main', 'breakfast-main', 'breakfast-main-pudding', 'breakfast-two-main-pudding']);

  function unique(values) {
    return values.filter(function (value, index) { return values.indexOf(value) === index; });
  }

  function isSafeNonNegativeInteger(value) {
    return Number.isSafeInteger(value) && value >= 0;
  }

  function parseQuantity(value, maximum) {
    var parsed;
    if (typeof value === 'number') parsed = value;
    else if (typeof value === 'string' && /^(?:0|[1-9]\d*)$/.test(value.trim())) parsed = Number(value);
    else return { valid: false, value: 0 };
    return {
      valid: isSafeNonNegativeInteger(parsed) && parsed <= maximum,
      value: isSafeNonNegativeInteger(parsed) && parsed <= maximum ? parsed : 0
    };
  }

  function formatMoney(pence) {
    if (!isSafeNonNegativeInteger(pence)) return '';
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: pence % 100 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    }).format(pence / 100);
  }

  function plural(value, singular, pluralForm) {
    return value + ' ' + (value === 1 ? singular : (pluralForm || singular + 's'));
  }

  function calculatePricing(subtotalPence, caseCount, rules) {
    if (!isSafeNonNegativeInteger(subtotalPence) || !isSafeNonNegativeInteger(caseCount)) return null;
    // Whole-case prices are additive. Retain zero-value fields for existing consumers.
    if (rules && (!Array.isArray(rules.discountBands) || rules.discountBands.length !== 0)) return null;
    return { subtotalPence: subtotalPence, discountBasisPoints: 0, pricePence: subtotalPence, savingPence: 0 };
  }

  function savingDescription() {
    return '';
  }

  // Customer delivery estimate for eligible England, Scotland and Wales addresses.
  // Food price and quote routing never include this charge. Shopify must separately
  // enforce the same case-based delivery rule before checkout is activated.
  function deliveryForSelection(plan) {
    if (!plan || !plan.valid || !Array.isArray(plan.items) || !plan.items.length ||
        !Number.isSafeInteger(plan.caseCount) || plan.caseCount < 1 ||
        !Number.isSafeInteger(plan.pricePence) || plan.pricePence <= 0 ||
        (plan.invalidIds && plan.invalidIds.length)) return null;
    var cases = 0;
    for (var item of plan.items) {
      if (!Number.isSafeInteger(item.quantity) || item.quantity < 1 || item.quantity > 999) return null;
      cases += item.quantity;
    }
    if (cases !== plan.caseCount) return null;
    var deliveryPence = cases < 3 ? 5000 : 0;
    var totalPence = plan.pricePence + deliveryPence;
    if (!Number.isSafeInteger(totalPence)) return null;
    return { foodSubtotalPence: plan.pricePence, deliveryPence: deliveryPence, totalPence: totalPence,
      scope: 'eligible England, Scotland and Wales addresses', estimated: true };
  }

  function sameSequence(left, right) {
    return left.length === right.length && left.every(function (value, index) { return value === right[index]; });
  }

  function familySignatures(data) {
    return Object.keys(EXPECTED_FAMILY_IDS).map(function (familyId) {
      var family = data.families && data.families[familyId];
      return family ? [familyId, family.name, family.description].join('|') : '';
    });
  }

  function recipeSignatures(data) {
    return data.recipes.map(function (recipe) {
      return [
        recipe.id,
        recipe.name,
        recipe.category,
        recipe.casePricePence,
        recipe.publicBuilderEnabled,
        recipe.productHandle === null ? '-' : recipe.productHandle,
        recipe.imageKey === null ? '-' : recipe.imageKey,
        recipe.supplierSku
      ].join('|');
    });
  }

  function readyMadeSignatures(data) {
    return data.readyMadeReserves.map(function (readyMade) {
      var components = Array.isArray(readyMade.components) ? readyMade.components.map(function (component) {
        return component.recipeId + ':' + component.quantity;
      }).join(',') : '';
      return [
        readyMade.id,
        readyMade.familyId,
        readyMade.name,
        readyMade.description,
        readyMade.caseCount,
        readyMade.tinCount,
        readyMade.pricePence,
        readyMade.subtotalPence,
        readyMade.savingPence,
        readyMade.discountBasisPoints,
        readyMade.journey,
        readyMade.featured,
        components
      ].join('|');
    });
  }

  function resolveBuilderJourney(pricePence, caseCount, rules) {
    var minimumCases = rules && isSafeNonNegativeInteger(rules.minimumCases) ? rules.minimumCases : 1;
    var quotePricePence = rules && isSafeNonNegativeInteger(rules.quotePricePence) ? rules.quotePricePence : 200000;
    var quoteCaseThreshold = rules && isSafeNonNegativeInteger(rules.quoteCaseThreshold) ? rules.quoteCaseThreshold : 40;
    if (!isSafeNonNegativeInteger(pricePence) || !isSafeNonNegativeInteger(caseCount)) {
      return { state: 'invalid', valid: false, label: 'Review your selection', reason: 'Choose recipes available in Build Your Own and use whole case quantities only.' };
    }
    if (caseCount < minimumCases) {
      var remaining = minimumCases - caseCount;
      return {
        state: 'blocked',
        valid: false,
        label: 'Choose more cases',
        reason: 'Choose at least ' + plural(remaining, 'case') + '. Each case contains six tins of one recipe.'
      };
    }
    if (pricePence >= quotePricePence || caseCount > quoteCaseThreshold) {
      return { state: 'quote', valid: true, label: 'Request a quote', reason: 'Request a quote' };
    }
    return { state: 'enquiry', valid: true, label: 'Ready to enquire', reason: 'Ready to enquire' };
  }

  function validateCatalogue(data) {
    var errors = [];
    if (!data || typeof data !== 'object') return { valid: false, errors: ['Catalogue is not an object.'] };
    var topLevelKeys = Object.keys(data).sort().join(',');
    if (topLevelKeys !== 'discountBands,families,maximumCasesPerRecipe,minimumCases,quoteCaseThreshold,quotePricePence,readyMadeReserves,recipes,schemaVersion,tinsPerCase,version') errors.push('Unexpected catalogue fields.');
    if (data.version !== '1.9.36' || data.schemaVersion !== 3) errors.push('Unexpected catalogue version.');
    if (!Array.isArray(data.discountBands) || data.discountBands.length !== 0) errors.push('Quantity discounts must be disabled.');
    if (data.tinsPerCase !== 6 || data.minimumCases !== 1 || data.maximumCasesPerRecipe !== 999) errors.push('Invalid case rules.');
    if (data.quotePricePence !== 200000 || data.quoteCaseThreshold !== 40) errors.push('Invalid route rules.');
    if (!data.families || typeof data.families !== 'object' || Array.isArray(data.families)) errors.push('Invalid families.');
    if (!Array.isArray(data.recipes) || data.recipes.length !== 20) errors.push('Expected exactly 20 recipes.');
    if (!Array.isArray(data.readyMadeReserves) || data.readyMadeReserves.length !== 14) errors.push('Expected exactly fourteen ready-made reserves.');
    if (Array.isArray(data.recipes) && !data.recipes.every(function (recipe) { return recipe && typeof recipe === 'object' && !Array.isArray(recipe); })) errors.push('Invalid recipe rows.');
    if (Array.isArray(data.readyMadeReserves) && !data.readyMadeReserves.every(function (readyMade) {
      return readyMade && typeof readyMade === 'object' && !Array.isArray(readyMade) && Array.isArray(readyMade.components) && readyMade.components.every(function (component) {
        return component && typeof component === 'object' && !Array.isArray(component);
      });
    })) errors.push('Invalid ready-made reserve rows.');
    if (errors.length) return { valid: false, errors: errors };

    var ruleSignature = [data.version, data.schemaVersion, data.tinsPerCase, data.minimumCases, data.maximumCasesPerRecipe, data.quotePricePence, data.quoteCaseThreshold].join('|');
    if (ruleSignature !== FROZEN_RULE_SIGNATURE) errors.push('Catalogue rules differ from the frozen expected manifest.');
    if (Object.keys(data.families).sort().join(',') !== 'breakfast-main,breakfast-main-pudding,breakfast-two-main-pudding,main-meals,vegetarian') errors.push('Unexpected family IDs.');
    Object.keys(data.families).forEach(function (familyId) {
      var family = data.families[familyId];
      if (!family || typeof family !== 'object' || Array.isArray(family) || Object.keys(family).sort().join(',') !== 'description,name') errors.push('Unexpected family fields for ' + familyId + '.');
    });

    var recipeIds = data.recipes.map(function (recipe) { return recipe.id; });
    if (unique(recipeIds).length !== 20) errors.push('Recipe IDs must be unique.');
    var publicRecipes = data.recipes.filter(function (recipe) { return recipe.publicBuilderEnabled === true; });
    if (publicRecipes.length !== 10) errors.push('Expected exactly ten public builder recipes.');
    if (unique(publicRecipes.map(function (recipe) { return recipe.productHandle; })).length !== 10) errors.push('Public product handles must be unique.');

    data.recipes.forEach(function (recipe) {
      var keys = Object.keys(recipe).sort().join(',');
      if (keys !== 'casePricePence,category,id,imageKey,name,productHandle,publicBuilderEnabled,storefrontEligible,supplierSku') errors.push('Unexpected public recipe fields for ' + recipe.id + '.');
      if (!recipe.id || !recipe.name || CATEGORY_ORDER.indexOf(recipe.category) < 0) errors.push('Invalid recipe identity for ' + recipe.id + '.');
      if (!Number.isSafeInteger(recipe.casePricePence) || recipe.casePricePence <= 0) errors.push('Invalid case price for ' + recipe.id + '.');
      if (!/^\d{6}$/.test(recipe.supplierSku)) errors.push('Invalid supplier SKU for ' + recipe.id + '.');
      if (typeof recipe.storefrontEligible !== 'boolean') errors.push('Invalid storefront eligibility for ' + recipe.id + '.');
      if (recipe.publicBuilderEnabled && !recipe.productHandle) errors.push('Missing public handle for ' + recipe.id + '.');
      if (!recipe.publicBuilderEnabled && recipe.productHandle !== null) errors.push('A non-public recipe exposes a product handle for ' + recipe.id + '.');
      if (!recipe.publicBuilderEnabled && recipe.storefrontEligible) errors.push('A non-public recipe is storefront eligible for ' + recipe.id + '.');
    });

    var recipeMap = Object.create(null);
    data.recipes.forEach(function (recipe) { recipeMap[recipe.id] = recipe; });
    var readyMadeIds = data.readyMadeReserves.map(function (readyMade) { return readyMade.id; });
    if (unique(readyMadeIds).length !== 14) errors.push('Ready-made reserve IDs must be unique.');
    Object.keys(EXPECTED_FAMILY_IDS).forEach(function (familyId) {
      var actual = data.readyMadeReserves.filter(function (readyMade) { return readyMade.familyId === familyId; })
        .map(function (readyMade) { return readyMade.id; });
      if (JSON.stringify(actual) !== JSON.stringify(EXPECTED_FAMILY_IDS[familyId])) errors.push('Invalid ' + familyId + ' ladder.');
    });

    data.readyMadeReserves.forEach(function (readyMade) {
      var readyMadeKeys = Object.keys(readyMade).sort().join(',');
      if (readyMadeKeys !== 'caseCount,components,description,discountBasisPoints,familyId,featured,id,journey,name,pricePence,savingPence,subtotalPence,tinCount') errors.push('Unexpected ready-made reserve fields for ' + readyMade.id + '.');
      if (!Array.isArray(readyMade.components) || !readyMade.components.length) errors.push('Missing components for ' + readyMade.id + '.');
      var cases = 0;
      var price = 0;
      (readyMade.components || []).forEach(function (component) {
        if (Object.keys(component).sort().join(',') !== 'quantity,recipeId') errors.push('Unexpected component fields in ' + readyMade.id + '.');
        var recipe = recipeMap[component.recipeId];
        if (!recipe) errors.push('Unknown component ' + component.recipeId + ' in ' + readyMade.id + '.');
        if (recipe && !recipe.publicBuilderEnabled && ADDITIONAL_RECIPE_IDS.indexOf(recipe.id) < 0) errors.push('Pack component is not builder-selectable in ' + readyMade.id + '.');
        if (!Number.isSafeInteger(component.quantity) || component.quantity <= 0) errors.push('Invalid component quantity in ' + readyMade.id + '.');
        if (recipe && Number.isSafeInteger(component.quantity) && component.quantity > 0) {
          cases += component.quantity;
          price += recipe.casePricePence * component.quantity;
        }
      });
      if (cases !== readyMade.caseCount || readyMade.tinCount !== cases * 6) errors.push('Case/tin mismatch for ' + readyMade.id + '.');
      var pricing = calculatePricing(price, cases, data);
      if (!pricing || pricing.pricePence !== readyMade.pricePence || pricing.subtotalPence !== readyMade.subtotalPence || pricing.savingPence !== readyMade.savingPence || pricing.discountBasisPoints !== readyMade.discountBasisPoints) errors.push('Price mismatch for ' + readyMade.id + '.');
      if (pricing && resolveBuilderJourney(pricing.pricePence, cases, data).state !== readyMade.journey) errors.push('Journey mismatch for ' + readyMade.id + '.');
    });
    var featured = data.readyMadeReserves.filter(function (readyMade) { return readyMade.featured; }).map(function (readyMade) { return readyMade.id; });
    if (JSON.stringify(featured) !== JSON.stringify(FEATURED_IDS)) errors.push('Featured reserves do not match the frozen manifest.');
    var secondary = data.readyMadeReserves.filter(function (readyMade) { return !readyMade.featured; }).map(function (readyMade) { return readyMade.id; });
    if (JSON.stringify(secondary) !== JSON.stringify(SECONDARY_IDS)) errors.push('Secondary reserves do not match the frozen manifest.');
    if (!sameSequence(familySignatures(data), FROZEN_FAMILY_SIGNATURES)) errors.push('Families differ from the frozen expected manifest.');
    if (!sameSequence(recipeSignatures(data), FROZEN_RECIPE_SIGNATURES)) errors.push('Recipes differ from the frozen expected manifest.');
    if (!sameSequence(readyMadeSignatures(data), FROZEN_READY_MADE_SIGNATURES)) errors.push('Ready-made reserves differ from the frozen expected manifest.');
    return { valid: errors.length === 0, errors: errors };
  }

  function ReserveCatalogue(data) {
    var validation = validateCatalogue(data);
    if (!validation.valid) throw new Error(validation.errors.join(' '));
    this.data = data;
    this.recipes = Object.create(null);
    this.readyMadeReserves = Object.create(null);
    data.recipes.forEach(function (recipe) { this.recipes[recipe.id] = recipe; }, this);
    data.readyMadeReserves.forEach(function (readyMade) { this.readyMadeReserves[readyMade.id] = readyMade; }, this);
    this.publicRecipes = data.recipes.filter(function (recipe) { return recipe.publicBuilderEnabled && recipe.storefrontEligible; });
    this.builderRecipes = this.publicRecipes.concat(ADDITIONAL_RECIPE_IDS.map(function (id) { return this.recipes[id]; }, this));
  }

  ReserveCatalogue.prototype.groupItems = function (items) {
    return items.map(function (item) {
      var recipe = this.recipes[item.recipeId];
      return { recipeId: recipe.id, supplierSku: recipe.supplierSku, name: recipe.name, category: recipe.category, quantity: item.quantity, specConfirmationRequired: requiresRecipeConfirmation(recipe.id) };
    }, this);
  };

  ReserveCatalogue.prototype.readyMadePlan = function (readyMadeId) {
    var readyMade = this.readyMadeReserves[readyMadeId];
    if (!readyMade) return null;
    return {
      schemaVersion: this.data.schemaVersion,
      kind: 'ready-made',
      journey: readyMade.journey,
      familyId: readyMade.familyId,
      readyMadeId: readyMade.id,
      name: readyMade.name,
      description: readyMade.description,
      items: this.groupItems(readyMade.components),
      caseCount: readyMade.caseCount,
      tinCount: readyMade.tinCount,
      pricePence: readyMade.pricePence,
      subtotalPence: readyMade.subtotalPence,
      savingPence: readyMade.savingPence,
      discountBasisPoints: readyMade.discountBasisPoints,
      valid: true
    };
  };

  ReserveCatalogue.prototype.calculateBuild = function (quantities) {
    var supplied = quantities && typeof quantities === 'object' && !Array.isArray(quantities) ? quantities : {};
    var builderIds = this.builderRecipes.map(function (recipe) { return recipe.id; });
    var invalidIds = Object.keys(supplied).filter(function (id) { return builderIds.indexOf(id) < 0; });
    var items = [];
    var caseCount = 0;
    var pricePence = 0;
    this.builderRecipes.forEach(function (recipe) {
      var raw = Object.prototype.hasOwnProperty.call(supplied, recipe.id) ? supplied[recipe.id] : 0;
      var parsed = parseQuantity(raw, this.data.maximumCasesPerRecipe);
      if (!parsed.valid) invalidIds.push(recipe.id);
      if (parsed.value > 0) {
        items.push({ recipeId: recipe.id, supplierSku: recipe.supplierSku, name: recipe.name, category: recipe.category, quantity: parsed.value, specConfirmationRequired: requiresRecipeConfirmation(recipe.id) });
        caseCount += parsed.value;
        pricePence += recipe.casePricePence * parsed.value;
      }
    }, this);
    var pricing = calculatePricing(pricePence, caseCount, this.data);
    var arithmeticSafe = Boolean(pricing) && isSafeNonNegativeInteger(caseCount * this.data.tinsPerCase);
    if (!arithmeticSafe) invalidIds.push('arithmetic');
    var route = invalidIds.length ? resolveBuilderJourney(NaN, NaN, this.data) : resolveBuilderJourney(pricing.pricePence, caseCount, this.data);
    return {
      schemaVersion: this.data.schemaVersion,
      kind: 'builder',
      journey: route.state === 'quote' ? 'quote' : 'enquiry',
      familyId: null,
      readyMadeId: null,
      name: 'Build Your Own selection',
      items: items,
      caseCount: arithmeticSafe ? caseCount : 0,
      tinCount: arithmeticSafe ? caseCount * this.data.tinsPerCase : 0,
      pricePence: arithmeticSafe ? pricing.pricePence : 0,
      subtotalPence: arithmeticSafe ? pricing.subtotalPence : 0,
      savingPence: arithmeticSafe ? pricing.savingPence : 0,
      discountBasisPoints: arithmeticSafe ? pricing.discountBasisPoints : 0,
      route: route,
      invalidIds: unique(invalidIds),
      valid: invalidIds.length === 0 && route.valid
    };
  };

  function selectionSummary(plan) {
    var recipes = plan.items.map(function (item) { return item.quantity + ' x ' + item.name + ' (supplier SKU ' + item.supplierSku + (item.specConfirmationRequired ? '; supplied code and product details require confirmation' : '') + ')'; }).join('; ');
    var status = plan.journey === 'quote' ? 'Quote requested' : 'Final details confirmed before payment';
    return plan.name + '; ' + recipes + '; ' + plural(plan.caseCount, 'case') + '; ' + plural(plan.tinCount, 'tin') + '; ' + formatMoney(plan.pricePence) + '; ' + status;
  }

  function builderCtaLabel(plan) {
    return plan && plan.journey === 'quote' ? 'Review quote selection' : 'Use this selection for enquiry';
  }

  function builderAnnouncement(plan, action) {
    var prefix = action || 'Selection updated.';
    var status = plan && plan.valid ? (plan.journey === 'quote' ? 'Request a quote' : 'Ready to review') : (plan && plan.route && plan.route.reason ? plan.route.reason : 'Review your selection');
    if (!/[.!?]$/.test(prefix)) prefix += '.';
    if (!/[.!?]$/.test(status)) status += '.';
    return prefix + ' ' + plural(plan.caseCount, 'case') + ', ' + plural(plan.tinCount, 'tin') + ', ' + formatMoney(plan.pricePence) + '. ' + status;
  }

  function customerStatus(plan) {
    return plan.journey === 'quote' ? 'Quote details confirmed with your enquiry' : 'Final details confirmed with your enquiry';
  }

  function encodeSelection(plan) {
    if (!plan || !plan.valid) return null;
    if (plan.kind === 'ready-made') return 'r.' + plan.readyMadeId;
    if (plan.kind === 'builder') return 'b.' + plan.items.map(function (item) { return item.recipeId + ':' + item.quantity; }).join(',');
    return null;
  }

  // Browsing drafts may be below the enquiry minimum; the order rules still apply.
  function encodeBuilderDraft(plan) {
    if (!plan || plan.kind !== 'builder' || !Array.isArray(plan.invalidIds) || plan.invalidIds.length) return null;
    return 'b.' + plan.items.map(function (item) { return item.recipeId + ':' + item.quantity; }).join(',');
  }

  ReserveCatalogue.prototype.parseBuilderDraft = function (token) {
    if (typeof token !== 'string' || token.length > 2000 || token.indexOf('b.') !== 0) return null;
    var quantities = Object.create(null);
    if (token !== 'b.') {
      var rows = token.slice(2).split(',');
      for (var index = 0; index < rows.length; index += 1) {
        var parts = rows[index].split(':');
        if (parts.length !== 2 || Object.prototype.hasOwnProperty.call(quantities, parts[0]) || !/^[1-9]\d*$/.test(parts[1])) return null;
        quantities[parts[0]] = parts[1];
      }
    }
    var plan = this.calculateBuild(quantities);
    return plan.invalidIds.length ? null : plan;
  };

  ReserveCatalogue.prototype.parseSelection = function (token) {
    if (typeof token !== 'string' || !token) return null;
    if (/^[rfe]\.[a-z0-9-]+$/.test(token)) return this.readyMadePlan(token.slice(2));
    if (token.indexOf('b.') !== 0 || token.length <= 2) return null;
    var quantities = {};
    var rows = token.slice(2).split(',');
    for (var index = 0; index < rows.length; index += 1) {
      var parts = rows[index].split(':');
      if (parts.length !== 2 || Object.prototype.hasOwnProperty.call(quantities, parts[0])) return null;
      quantities[parts[0]] = parts[1];
    }
    var plan = this.calculateBuild(quantities);
    return plan.valid ? plan : null;
  };

  function deriveRecoveryState(catalogue, token) {
    if (typeof token !== 'string' || !token) return { state: 'clean', plan: null, quantities: {} };
    var migration = migrationForSelection(catalogue, token);
    if (migration) return { state: 'migration', plan: null, quantities: {}, migration: migration };
    var plan = catalogue.parseSelection(token);
    if (!plan) return { state: 'invalid', plan: null, quantities: {} };
    var quantities = {};
    if (plan.kind === 'builder') plan.items.forEach(function (item) { quantities[item.recipeId] = item.quantity; });
    return { state: 'valid', plan: plan, quantities: quantities };
  }

  function migrationForSelection(catalogue, token) {
    if (typeof token !== 'string' || !/^[rfe]\.[a-z0-9-]+$/.test(token)) return null;
    var legacyId = token.slice(2);
    var replacementId = LEGACY_PACK_IDS[legacyId];
    var replacement = replacementId ? catalogue.readyMadePlan(replacementId) : null;
    if (!replacement) return null;
    return { legacyId: legacyId, replacementId: replacementId, replacement: replacement };
  }

  function normalisePlannerPeople(value) {
    var parsed;
    if (typeof value === 'number') parsed = value;
    else if (typeof value === 'string' && /^[1-8]$/.test(value.trim())) parsed = Number(value);
    else return null;
    return Number.isSafeInteger(parsed) && parsed >= 1 && parsed <= 8 ? parsed : null;
  }

  function calculatePlanner(input) {
    var supplied = input && typeof input === 'object' && !Array.isArray(input) ? input : {};
    var people = normalisePlannerPeople(supplied.people);
    var period = PLANNER_PERIODS[supplied.periodId];
    var pattern = PLANNER_PATTERNS[supplied.patternId];
    var errors = [];
    if (people === null) errors.push('Choose a whole number of people from 1 to 8.');
    if (!period) errors.push('Choose one of the listed planning periods.');
    if (!pattern) errors.push('Choose one of the listed eating patterns.');
    if (errors.length) return { valid: false, errors: errors };
    return {
      valid: true,
      schemaVersion: 1,
      people: people,
      periodId: period.id,
      periodLabel: period.label,
      days: period.days,
      patternId: pattern.id,
      patternLabel: pattern.label,
      counts: {
        breakfast: people * period.days * pattern.breakfast,
        main: people * period.days * pattern.main,
        pudding: people * period.days * pattern.pudding
      }
    };
  }

  function plannerEquations(result) {
    if (!result || !result.valid) return [];
    var categories = [
      { key: 'breakfast', singular: 'breakfast', plural: 'breakfasts' },
      { key: 'main', singular: 'main meal', plural: 'main meals' },
      { key: 'pudding', singular: 'pudding', plural: 'puddings' }
    ];
    return categories.filter(function (category) { return result.counts[category.key] > 0; }).map(function (category) {
      var count = result.counts[category.key];
      return new Intl.NumberFormat('en-GB').format(count) + ' ' + (count === 1 ? category.singular : category.plural);
    });
  }

  function plannerContext(result) {
    if (!result || !result.valid) return '';
    return 'For ' + plural(result.people, 'person', 'people') + ' over ' + plural(result.days, 'day') + ':';
  }

  function plannerAnnouncement(result) {
    if (!result || !result.valid) return 'Review the planning details and try again.';
    return 'Your plan. ' + plannerContext(result) + ' ' + plannerEquations(result).join('; ') + '.';
  }

  function encodePlannerState(result) {
    if (!result || !result.valid) return null;
    var period = PLANNER_PERIODS[result.periodId];
    var pattern = PLANNER_PATTERNS[result.patternId];
    if (!period || !pattern) return null;
    return ['p', result.people, period.token, pattern.token].join('.');
  }

  function parsePlannerState(token) {
    if (typeof token !== 'string') return { state: 'clean', result: null };
    if (!token) return { state: 'clean', result: null };
    var match = token.match(/^p\.([1-8])\.(2w|1m|3m|6m|12m)\.(main|bm|bmp|b2mp)$/);
    if (!match) return { state: 'invalid', result: null };
    var periodId = PLANNER_PERIOD_ORDER.find(function (id) { return PLANNER_PERIODS[id].token === match[2]; });
    var patternId = PLANNER_PATTERN_ORDER.find(function (id) { return PLANNER_PATTERNS[id].token === match[3]; });
    var result = calculatePlanner({ people: Number(match[1]), periodId: periodId, patternId: patternId });
    return result.valid ? { state: 'valid', result: result } : { state: 'invalid', result: null };
  }

  function appendText(parent, tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    node.textContent = text;
    parent.appendChild(node);
    return node;
  }

  function initialise(root) {
    var dataNode = root.querySelector('[data-phq-v1711-data]');
    var data;
    try { data = JSON.parse(dataNode ? dataNode.textContent : ''); }
    catch (error) { root.setAttribute('data-phq-v1711-error', 'catalogue'); return; }
    var validation = validateCatalogue(data);
    if (!validation.valid) { root.setAttribute('data-phq-v1711-error', 'catalogue'); return; }
    var catalogue = new ReserveCatalogue(data);
    var review = root.querySelector('[data-phq-v1711-review]');
    var reviewTitle = root.querySelector('[data-phq-v1711-review-title]');
    var reviewStatus = root.querySelector('[data-phq-v1711-review-status]');
    var reviewItems = root.querySelector('[data-phq-v1711-review-items]');
    var reviewCases = root.querySelector('[data-phq-v1711-review-cases]');
    var reviewTins = root.querySelector('[data-phq-v1711-review-tins]');
    var reviewPrice = root.querySelector('[data-phq-v1711-review-price]');
    var reviewSaving = root.querySelector('[data-phq-v1711-review-saving]');
    var plannerReview = root.querySelector('[data-phq-v1711-planner-review]');
    var plannerReviewItems = root.querySelector('[data-phq-v1711-planner-review-items]');
    var plannerReviewContext = root.querySelector('[data-phq-v1711-planner-review-context]');
    var submit = root.querySelector('[data-phq-v1711-submit]');
    var contactForm = root.querySelector('.phq-v1711__contact-form');
    // Use Shopify's rendered form status; never invent a client-side success flag.
    var serverFormSuccess = root.querySelector('[data-phq-v1711-form-success]');
    var selectionChangedAfterSuccess = false;
    var builderCases = root.querySelector('[data-phq-v1711-builder-cases]');
    var builderTins = root.querySelector('[data-phq-v1711-builder-tins]');
    var builderPrice = root.querySelector('[data-phq-v1711-builder-price]');
    var builderSaving = root.querySelector('[data-phq-v1711-builder-saving]');
    var builderStatus = root.querySelector('[data-phq-v1711-builder-status]');
    var builderItems = root.querySelector('[data-phq-v1711-builder-items]');
    var useBuilder = root.querySelector('[data-phq-v1711-use-builder]');
    var live = root.querySelector('[data-phq-v1711-live]');
    var restoreMessage = root.querySelector('[data-phq-v1711-restore-message]');
    var migrationNotice = root.querySelector('[data-phq-v1711-migration]');
    var migrationMessage = root.querySelector('[data-phq-v1711-migration-message]');
    var migrationReview = root.querySelector('[data-phq-v1711-migration-review]');
    var guidedApply = root.querySelector('[data-phq-v1711-apply-guided]');
    var guidedInputs = Array.prototype.slice.call(root.querySelectorAll('[data-phq-v1711-guided]'));
    var quantityInputs = Array.prototype.slice.call(root.querySelectorAll('[data-phq-v1711-quantity]'));
    var plannerForm = root.querySelector('[data-phq-v1711-planner-form]');
    var plannerPeople = root.querySelector('[data-phq-v1711-planner-people]');
    var plannerResult = root.querySelector('[data-phq-v1711-planner-result]');
    var plannerPrompt = root.querySelector('[data-phq-v1711-planner-prompt]');
    var plannerOutput = root.querySelector('[data-phq-v1711-planner-output]');
    var plannerEquationsList = root.querySelector('[data-phq-v1711-planner-equations]');
    var plannerContextText = root.querySelector('[data-phq-v1711-planner-context]');
    var plannerError = root.querySelector('[data-phq-v1711-planner-error]');
    var plannerLive = root.querySelector('[data-phq-v1711-planner-live]');
    var plannerClear = root.querySelector('[data-phq-v1711-planner-clear]');
    var planSummary = root.querySelector('[data-phq-v1711-plan-summary]');
    var planSummaryContext = root.querySelector('[data-phq-v1711-plan-context]');
    var planSummaryItems = root.querySelector('[data-phq-v1711-plan-items]');
    var planEditor = root.querySelector('[data-phq-v1711-plan-editor]');
    var planEdit = root.querySelector('[data-phq-v1711-plan-edit]');
    var planRemove = root.querySelector('[data-phq-v1711-plan-remove]');
    var planCancel = root.querySelector('[data-phq-v1711-plan-cancel]');
    var hasPlanner = Boolean(plannerForm && plannerPeople && plannerResult && plannerPrompt && plannerOutput && plannerEquationsList && plannerError && plannerLive && plannerClear);
    var hasBuilder = Boolean(builderCases && builderTins && builderPrice && builderStatus && builderItems && useBuilder && quantityInputs.length);
    var hasReview = Boolean(review && reviewTitle && reviewStatus && reviewItems && reviewCases && reviewTins && reviewPrice && submit && contactForm);
    var familyDisclosures = Array.prototype.slice.call(root.querySelectorAll('.phq-v1711__offer-family'));
    var currentSelection = null;
    var lastSelectionToken;
    var lastMigrationSource;
    var lastDraftToken;
    var recoveringSelection = false;
    var draftRecoveryFailed = false;
    var currentMigration = null;
    var migrationAcknowledged = false;
    var currentPlanner = null;
    var plannerBeforeEdit = null;
    var plannerStateKnown = false;
    var plannerStorageKey = 'preparehq.planner.v1';
    var builderCommitted = false;
    var lastBuilderPlan = catalogue.calculateBuild({});

    if (familyDisclosures.length && typeof window.matchMedia === 'function') {
      var familyDesktopQuery = window.matchMedia('(min-width: 750px)');
      var syncingFamilies = false;
      familyDisclosures.forEach(function (details) {
        details.addEventListener('toggle', function () {
          if (!syncingFamilies && !familyDesktopQuery.matches) details.setAttribute('data-phq-v180-user-toggled', 'true');
        });
      });
      var syncFamilyDisclosures = function () {
        syncingFamilies = true;
        familyDisclosures.forEach(function (details, index) {
          if (familyDesktopQuery.matches) details.open = true;
          else if (!details.hasAttribute('data-phq-v180-user-toggled')) details.open = index === 0;
        });
        syncingFamilies = false;
      };
      syncFamilyDisclosures();
      if (typeof familyDesktopQuery.addEventListener === 'function') familyDesktopQuery.addEventListener('change', syncFamilyDisclosures);
      else if (typeof familyDesktopQuery.addListener === 'function') familyDesktopQuery.addListener(syncFamilyDisclosures);
      var openTargetFamily = function () {
        var targetId = window.location.hash ? window.location.hash.slice(1) : '';
        var hashTarget = targetId ? document.getElementById(targetId) : null;
        var targetFamily = familyDisclosures.find(function (details) {
          return details.id === targetId || Boolean(hashTarget && details.contains(hashTarget));
        });
        if (targetFamily) targetFamily.open = true;
      };
      openTargetFamily();
      window.addEventListener('hashchange', openTargetFamily);
    }

    function announce(message) {
      if (!live) return;
      live.textContent = '';
      window.requestAnimationFrame(function () { live.textContent = message; });
    }

    function announcePlanner(message) {
      if (!plannerLive) return;
      plannerLive.textContent = '';
      window.requestAnimationFrame(function () { plannerLive.textContent = message; });
    }

    function readQuantities() {
      var quantities = {};
      quantityInputs.forEach(function (input) { quantities[input.getAttribute('data-phq-v1711-quantity')] = input.value; });
      return quantities;
    }

    function setQuantities(quantities) {
      quantityInputs.forEach(function (input) {
        var id = input.getAttribute('data-phq-v1711-quantity');
        input.value = Object.prototype.hasOwnProperty.call(quantities, id) ? String(quantities[id]) : '0';
      });
    }

    function setHidden(field, value) {
      if (!contactForm) return;
      var input = contactForm.querySelector('[data-phq-v1711-field="' + field + '"]');
      if (input) input.value = value;
    }

    function renderSaving(node, plan) {
      if (!node) return;
      node.textContent = savingDescription(plan);
      node.hidden = !node.textContent;
    }

    function clearMigration() {
      currentMigration = null;
      migrationAcknowledged = false;
      if (migrationNotice) migrationNotice.hidden = true;
      if (migrationMessage) migrationMessage.textContent = '';
      if (migrationReview) migrationReview.hidden = false;
    }

    function renderMigration(migration, acknowledged) {
      currentMigration = migration;
      migrationAcknowledged = Boolean(acknowledged);
      if (migrationMessage) migrationMessage.textContent = 'The pack range has changed since this link was created. The updated option is ' + migration.replacement.name + ' at ' + formatMoney(migration.replacement.pricePence) + '. Review its contents, daily serving pattern and price before sending an enquiry.';
      if (migrationNotice) migrationNotice.hidden = false;
      if (migrationReview) migrationReview.hidden = migrationAcknowledged;
    }

    function renderItems(parent, items) {
      if (!parent) return;
      parent.replaceChildren();
      items.forEach(function (item) { appendText(parent, 'li', '', item.quantity + ' × ' + item.name + ' case' + (item.quantity === 1 ? '' : 's')); });
    }

    function renderEquationItems(parent, result, context) {
      if (!parent) return;
      if (context) context.textContent = plannerContext(result);
      parent.replaceChildren();
      plannerEquations(result).forEach(function (equation) { appendText(parent, 'li', '', equation); });
    }

    function syncPlannerFields() {
      var result = currentPlanner && currentPlanner.valid ? currentPlanner : null;
      setHidden('planner_schema_version', result ? String(result.schemaVersion) : '');
      setHidden('planner_people', result ? String(result.people) : '');
      setHidden('planner_period', result ? result.periodLabel + ' (' + result.days + ' days)' : '');
      setHidden('planner_days', result ? String(result.days) : '');
      setHidden('planner_pattern', result ? result.patternLabel : '');
      setHidden('planner_breakfast', result ? String(result.counts.breakfast) : '');
      setHidden('planner_main', result ? String(result.counts.main) : '');
      setHidden('planner_pudding', result ? String(result.counts.pudding) : '');
    }

    function renderPlannerReview() {
      if (!plannerReview || !plannerReviewItems) return;
      if (!currentPlanner || !currentPlanner.valid) {
        plannerReview.hidden = true;
        plannerReviewItems.replaceChildren();
        if (plannerReviewContext) plannerReviewContext.textContent = '';
        return;
      }
      renderEquationItems(plannerReviewItems, currentPlanner, plannerReviewContext);
      plannerReview.hidden = false;
    }

    function renderPlanSummary() {
      if (!planSummary) return;
      planSummary.hidden = !(currentPlanner && currentPlanner.valid);
      renderEquationItems(planSummaryItems, currentPlanner, planSummaryContext);
    }

    function readStoredPlanner() {
      try { return window.sessionStorage.getItem(plannerStorageKey); }
      catch (error) { return null; }
    }

    function isHistoryNavigation() {
      try {
        var entry = window.performance.getEntriesByType('navigation')[0];
        return Boolean(entry && entry.type === 'back_forward');
      } catch (error) { return false; }
    }

    function reconcileHistoryInputs() {
      // Browser form restoration can happen after pageshow/popstate, including without BFCache.
      window.setTimeout(function () {
        if (currentPlanner && currentPlanner.valid) setPlannerControls(currentPlanner);
        if (hasBuilder) {
          if (serverFormSuccess && !selectionChangedAfterSuccess) setQuantities({});
          else if (builderCommitted && currentSelection && currentSelection.kind === 'builder') {
            var quantities = {};
            currentSelection.items.forEach(function (item) { quantities[item.recipeId] = item.quantity; });
            setQuantities(quantities);
          }
          updateBuilder();
        }
        syncPlannerFields();
        renderPlannerReview();
      }, 0);
    }

    function storePlanner(result) {
      plannerStateKnown = true;
      // An empty value records an intentional clear, including across cached page restores.
      try { window.sessionStorage.setItem(plannerStorageKey, encodePlannerState(result) || ''); }
      catch (error) { /* Journey links still carry the validated state when storage is blocked. */ }
    }

    function syncPlannerNavigation() {
      var token = encodePlannerState(currentPlanner) || '';
      var homePath = root.getAttribute('data-phq-home-url') || '/';
      var collectionPath = root.getAttribute('data-phq-collections-url') || '/collections';
      var paths = [homePath, collectionPath + '/shop-all-emergency-food', collectionPath + '/6-tin-food-boxes'];
      function normalPath(value) { return value.replace(/\/+$/, '') || '/'; }
      document.querySelectorAll('a[href]').forEach(function (link) {
        var original = link.getAttribute('data-phq-original-href') || link.getAttribute('href');
        if (!original || original.charAt(0) === '#' || link.hasAttribute('download')) return;
        try {
          var url = new URL(original, window.location.href);
          if (url.origin !== window.location.origin || !paths.some(function (path) { return normalPath(url.pathname) === normalPath(path); })) return;
          if (!link.hasAttribute('data-phq-original-href')) link.setAttribute('data-phq-original-href', original);
          if (plannerStateKnown) url.searchParams.set('phq_plan', token);
          else url.searchParams.delete('phq_plan');
          link.setAttribute('href', url.pathname + url.search + url.hash);
        } catch (error) { /* Leave unrelated or malformed navigation unchanged. */ }
      });
    }

    function syncBuilderDraft() {
      if (recoveringSelection) return;
      var token = draftRecoveryFailed ? null : encodeBuilderDraft(lastBuilderPlan);
      // Invalid input replaces older snapshots rather than silently reviving them.
      try { window.sessionStorage.setItem('preparehq.builder-draft.v1', token || 'invalid'); } catch (error) { /* Detail links still carry the draft. */ }
      root.querySelectorAll('.phq-v1711__recipe-details[href]').forEach(function (link) {
        try {
          var url = new URL(link.href, window.location.href);
          url.searchParams.set('phq_draft', token || 'invalid');
          url.searchParams.set('phq_plan', encodePlannerState(currentPlanner) || '');
          link.href = url.pathname + url.search + url.hash;
        } catch (error) { /* Leave malformed links unchanged. */ }
      });
      try {
        var current = new URL(window.location.href);
        if (!current.searchParams.has('phq') && (current.searchParams.has('phq_draft') || token !== 'b.')) {
          current.searchParams.set('phq_draft', token || 'invalid');
          history.replaceState(history.state || {}, '', current.pathname + current.search + current.hash);
          lastDraftToken = token || 'invalid';
        }
      } catch (error) { /* The visible selection remains usable without history. */ }
    }

    function closePlanEditor(shouldFocus) {
      if (!planEditor) return;
      planEditor.hidden = true;
      if (planEdit) planEdit.setAttribute('aria-expanded', 'false');
      plannerBeforeEdit = null;
      if (shouldFocus) {
        var target = planSummary && !planSummary.hidden ? planSummary.querySelector('h2') : root.querySelector('h1');
        if (target) { target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); }
      }
    }

    function renderReview(plan) {
      if (!hasReview) return;
      currentSelection = plan;
      reviewTitle.textContent = plan.name;
      reviewStatus.textContent = customerStatus(plan);
      renderItems(reviewItems, plan.items);
      reviewCases.textContent = String(plan.caseCount);
      reviewTins.textContent = String(plan.tinCount);
      reviewPrice.textContent = formatMoney(plan.pricePence);
      renderSaving(reviewSaving, plan);
      submit.textContent = plan.journey === 'quote' ? 'Request my quote' : 'Send my enquiry';
      setHidden('schema_version', String(plan.schemaVersion || data.schemaVersion || 1));
      setHidden('journey', plan.journey);
      setHidden('kind', plan.kind);
      setHidden('ready_made_id', plan.readyMadeId || '');
      setHidden('family_id', plan.familyId || '');
      setHidden('recipe_ids', plan.items.map(function (item) { return item.recipeId + ':' + item.quantity; }).join(','));
      setHidden('supplier_skus', plan.items.map(function (item) { return item.supplierSku + ':' + item.quantity; }).join(','));
      setHidden('selection', plan.items.map(function (item) { return item.quantity + ' x ' + item.name + ' case' + (item.quantity === 1 ? '' : 's'); }).join('; '));
      setHidden('summary', selectionSummary(plan));
      setHidden('cases', String(plan.caseCount));
      setHidden('tins', String(plan.tinCount));
      setHidden('price', formatMoney(plan.pricePence));
      setHidden('subtotal', formatMoney(plan.subtotalPence));
      setHidden('saving', formatMoney(plan.savingPence));
      setHidden('discount', String(plan.discountBasisPoints / 100) + '%');
      syncPlannerFields();
      renderPlannerReview();
      review.hidden = false;
    }

    function hideReview() {
      currentSelection = null;
      if (!review) return;
      review.hidden = true;
      ['schema_version', 'journey', 'kind', 'ready_made_id', 'family_id', 'recipe_ids', 'supplier_skus', 'selection', 'summary', 'cases', 'tins', 'price', 'subtotal', 'saving', 'discount'].forEach(function (field) { setHidden(field, ''); });
      renderSaving(reviewSaving, null);
    }

    function resetInteractiveState() {
      builderCommitted = false;
      draftRecoveryFailed = false;
      clearMigration();
      setQuantities({});
      guidedInputs.forEach(function (select) { select.value = ''; });
      if (guidedApply) guidedApply.disabled = true;
      hideReview();
      if (hasBuilder) updateBuilder();
    }

    function writeSelectionHistory(plan, replace) {
      var token = encodeSelection(plan);
      if (!token || typeof history === 'undefined') return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('phq', token);
        url.searchParams.delete('phq_draft');
        url.searchParams.delete('contact_posted');
        var migrationSource = currentMigration && migrationAcknowledged && plan.kind === 'ready-made' && plan.readyMadeId === currentMigration.replacementId ? currentMigration.legacyId : null;
        if (migrationSource) url.searchParams.set('phq_from', migrationSource);
        else url.searchParams.delete('phq_from');
        history[replace ? 'replaceState' : 'pushState']({ phq: token }, '', url.pathname + url.search + url.hash);
        lastSelectionToken = token;
        lastDraftToken = null;
        lastMigrationSource = migrationSource;
      } catch (error) { /* Selection still works without URL persistence. */ }
    }

    function clearSelectionHistory(replace) {
      if (typeof history === 'undefined') return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('phq');
        url.searchParams.delete('phq_draft');
        url.searchParams.delete('phq_from');
        history[replace ? 'replaceState' : 'pushState']({}, '', url.pathname + url.search + url.hash);
        lastSelectionToken = null;
        lastDraftToken = null;
        lastMigrationSource = null;
      } catch (error) { /* Ignore unavailable History API. */ }
    }

    function chooseReadyMade(readyMadeId, shouldScroll, acceptedMigration) {
      var plan = catalogue.readyMadePlan(readyMadeId);
      if (!plan) { hideReview(); announce('Please review your selection again.'); return; }
      selectionChangedAfterSuccess = true;
      if (!hasReview) {
        var comparisonPath = (root.getAttribute('data-phq-collections-url') || '/collections') + '/shop-all-emergency-food';
        var destination = new URL(comparisonPath, window.location.href);
        destination.searchParams.set('phq', encodeSelection(plan));
        if (acceptedMigration) destination.searchParams.set('phq_from', acceptedMigration.legacyId);
        if (plannerStateKnown) destination.searchParams.set('phq_plan', encodePlannerState(currentPlanner) || '');
        window.location.assign(destination.pathname + destination.search);
        return;
      }
      restoreMessage.hidden = true;
      clearMigration();
      if (acceptedMigration) renderMigration(acceptedMigration, true);
      builderCommitted = false;
      renderReview(plan);
      writeSelectionHistory(plan, false);
      announce(plan.name + ' is ready to review.');
      if (shouldScroll !== false) {
        review.scrollIntoView({ behavior: 'smooth', block: 'start' });
        reviewTitle.focus({ preventScroll: true });
      }
    }

    function updateBuilder(message) {
      if (message) { selectionChangedAfterSuccess = true; draftRecoveryFailed = false; }
      var plan = catalogue.calculateBuild(readQuantities());
      lastBuilderPlan = plan;
      builderCases.textContent = String(plan.caseCount);
      builderTins.textContent = String(plan.tinCount);
      builderPrice.textContent = formatMoney(plan.pricePence);
      var delivery = deliveryForSelection(plan);
      var builderDelivery = root.querySelector('[data-phq-v1711-builder-delivery]');
      var builderTotal = root.querySelector('[data-phq-v1711-builder-total]');
      if (builderDelivery) builderDelivery.textContent = delivery ? (delivery.deliveryPence ? formatMoney(delivery.deliveryPence) : 'Included') : '—';
      if (builderTotal) builderTotal.textContent = delivery ? formatMoney(delivery.totalPence) : '—';
      renderSaving(builderSaving, plan);
      builderStatus.textContent = plan.valid ? customerStatus(plan) : plan.route.reason;
      builderItems.hidden = plan.items.length === 0;
      renderItems(builderItems, plan.items);
      useBuilder.disabled = !plan.valid;
      useBuilder.setAttribute('aria-disabled', String(!plan.valid));
      useBuilder.textContent = builderCtaLabel(plan);
      if ((plan.valid || (message && !plan.invalidIds.length)) && !restoreMessage.hidden) {
        restoreMessage.hidden = true;
        clearSelectionHistory(true);
      }
      if (builderCommitted) {
        if (plan.valid) { renderReview(plan); writeSelectionHistory(plan, true); }
        else { builderCommitted = false; hideReview(); clearSelectionHistory(true); }
      }
      syncBuilderDraft();
      if (message) announce(builderAnnouncement(plan, message));
      return plan;
    }

    function applyQuantities(quantities, announcement) {
      selectionChangedAfterSuccess = true;
      draftRecoveryFailed = false;
      setQuantities(quantities);
      updateBuilder(announcement);
    }

    function populateGuidedStarter() {
      guidedInputs.forEach(function (select) {
        var category = select.getAttribute('data-phq-v1711-guided');
        catalogue.builderRecipes.filter(function (recipe) { return recipe.category === category; }).forEach(function (recipe) {
          var option = document.createElement('option');
          option.value = recipe.id;
          option.textContent = recipe.name;
          select.appendChild(option);
        });
        select.addEventListener('change', function () { guidedApply.disabled = !guidedInputs.every(function (input) { return Boolean(input.value); }); });
      });
    }

    function selectedRadioValue(name) {
      var selected = plannerForm.querySelector('input[name="' + name + '"]:checked');
      return selected ? selected.value : '';
    }

    function setPlannerControls(result) {
      if (!hasPlanner) return;
      plannerPeople.value = String(result.people);
      Array.prototype.forEach.call(plannerForm.querySelectorAll('input[name="phq_planning_period"]'), function (input) { input.checked = input.value === result.periodId; });
      Array.prototype.forEach.call(plannerForm.querySelectorAll('input[name="phq_eating_pattern"]'), function (input) { input.checked = input.value === result.patternId; });
    }

    function writePlannerHistory(result) {
      storePlanner(result);
      syncPlannerNavigation();
      if (typeof history === 'undefined') return;
      try {
        var url = new URL(window.location.href);
        var token = encodePlannerState(result);
        url.searchParams.set('phq_plan', token || '');
        history.replaceState(history.state || {}, '', url.pathname + url.search + url.hash);
      } catch (error) { /* Planning still works without URL persistence. */ }
    }

    function clearPlannerData(prompt, shouldAnnounce, updateUrl) {
      currentPlanner = null;
      if (hasPlanner) {
        plannerResult.setAttribute('data-state', 'empty');
        plannerOutput.hidden = true;
        plannerPrompt.hidden = false;
        plannerPrompt.textContent = prompt || 'Choose your planning details, then calculate.';
        plannerError.hidden = true;
        plannerError.textContent = '';
        plannerEquationsList.replaceChildren();
        if (plannerContextText) plannerContextText.textContent = '';
      }
      syncPlannerFields();
      renderPlannerReview();
      renderPlanSummary();
      syncPlannerNavigation();
      if (updateUrl) writePlannerHistory(null);
      if (shouldAnnounce) announcePlanner(prompt || 'Planning information cleared.');
    }

    function showPlannerError(message, shouldAnnounce) {
      clearPlannerData('Review the planning details, then calculate again.', false, false);
      writePlannerHistory(null);
      if (hasPlanner) {
        plannerError.textContent = message;
        plannerError.hidden = false;
        plannerResult.setAttribute('data-state', 'error');
      }
      if (planEditor) planEditor.hidden = false;
      if (planEdit) planEdit.setAttribute('aria-expanded', 'true');
      if (shouldAnnounce) announcePlanner(message);
    }

    function renderPlanner(result, shouldAnnounce) {
      currentPlanner = result;
      if (hasPlanner) {
        plannerResult.setAttribute('data-state', 'populated');
        plannerPrompt.hidden = true;
        plannerError.hidden = true;
        plannerError.textContent = '';
        renderEquationItems(plannerEquationsList, result, plannerContextText);
        plannerOutput.hidden = false;
      }
      syncPlannerFields();
      renderPlannerReview();
      renderPlanSummary();
      syncPlannerNavigation();
      if (shouldAnnounce) announcePlanner(plannerAnnouncement(result));
    }

    function recoverPlannerLocation(shouldAnnounce, preferStored) {
      var token = null;
      var stored = readStoredPlanner();
      try {
        var params = new URL(window.location.href).searchParams;
        token = params.getAll('phq_plan').length > 1 ? 'invalid' : params.get('phq_plan');
      }
      catch (error) { token = null; }
      if ((preferStored || token === null) && stored !== null) token = stored;
      plannerStateKnown = token !== null;
      var recovery = parsePlannerState(token || '');
      if (recovery.state === 'clean') {
        clearPlannerData('Choose your planning details, then calculate.', false, false);
        if (plannerStateKnown) writePlannerHistory(null);
        return;
      }
      if (recovery.state === 'invalid') {
        showPlannerError('That saved planning information could not be restored. Please choose the details again.', shouldAnnounce);
        return;
      }
      setPlannerControls(recovery.result);
      renderPlanner(recovery.result, shouldAnnounce);
      writePlannerHistory(recovery.result);
    }

    root.querySelectorAll('[data-phq-v1711-select-ready-made]').forEach(function (button) {
      button.addEventListener('click', function () { chooseReadyMade(button.getAttribute('data-phq-v1711-select-ready-made'), true); });
    });
    if (migrationReview) migrationReview.addEventListener('click', function () {
      if (currentMigration && !migrationAcknowledged) chooseReadyMade(currentMigration.replacementId, true, currentMigration);
    });
    if (hasBuilder) {
    ['pointerdown', 'focusin', 'click'].forEach(function (eventName) {
      root.addEventListener(eventName, function (event) {
        if (event.target.closest('.phq-v1711__recipe-details')) syncBuilderDraft();
      });
    });
    quantityInputs.forEach(function (input) {
      input.addEventListener('input', function () { updateBuilder('Selection updated.'); });
    });
    root.querySelectorAll('[data-phq-v1711-minus]').forEach(function (button) {
      button.addEventListener('click', function () {
        var input = root.querySelector('[data-phq-v1711-quantity="' + button.getAttribute('data-phq-v1711-minus') + '"]');
        var parsed = parseQuantity(input.value, data.maximumCasesPerRecipe);
        input.value = String(Math.max(0, parsed.valid ? parsed.value - 1 : 0));
        updateBuilder('One case removed.');
      });
    });
    root.querySelectorAll('[data-phq-v1711-plus]').forEach(function (button) {
      button.addEventListener('click', function () {
        var input = root.querySelector('[data-phq-v1711-quantity="' + button.getAttribute('data-phq-v1711-plus') + '"]');
        var parsed = parseQuantity(input.value, data.maximumCasesPerRecipe);
        if (parsed.valid && parsed.value < data.maximumCasesPerRecipe) {
          input.value = String(parsed.value + 1);
          updateBuilder('One case added.');
        } else announce('The maximum is 999 cases per recipe.');
      });
    });
    var presetButton = root.querySelector('[data-phq-v1711-apply-preset]');
    var presetIds = ['macaroni-cheese', 'five-bean-cassoulet', 'vegetable-chilli'];
    var presetAvailable = presetIds.every(function (id) { return catalogue.publicRecipes.some(function (recipe) { return recipe.id === id; }); });
    if (presetButton) {
      presetButton.disabled = !presetAvailable;
      presetButton.setAttribute('aria-disabled', String(!presetAvailable));
      presetButton.addEventListener('click', function () {
        if (!presetAvailable) return;
        applyQuantities({ 'macaroni-cheese': 1, 'five-bean-cassoulet': 1, 'vegetable-chilli': 1 }, 'Three-case preset applied.');
      });
    }
    root.querySelectorAll('[data-phq-v1711-apply-mix]').forEach(function (button) {
      var quantities = {}, validMix = true;
      (button.getAttribute('data-phq-v1711-apply-mix') || '').split(',').forEach(function (entry) {
        var parts = entry.split(':'), quantity = parseQuantity(parts[1], data.maximumCasesPerRecipe);
        if (parts.length !== 2 || !quantity.valid || quantity.value < 1 || Object.prototype.hasOwnProperty.call(quantities, parts[0]) || !catalogue.builderRecipes.some(function (recipe) { return recipe.id === parts[0]; })) { validMix = false; return; }
        quantities[parts[0]] = quantity.value;
      });
      var mixPlan = validMix ? catalogue.calculateBuild(quantities) : null;
      validMix = Boolean(mixPlan && mixPlan.valid && !mixPlan.items.some(function (item) { return item.specConfirmationRequired; }));
      button.disabled = !validMix;
      button.setAttribute('aria-disabled', String(!validMix));
      button.addEventListener('click', function () {
        if (!validMix) return;
        applyQuantities(quantities, 'Recipe mix applied. You can adjust the case quantities below.');
        var firstQuantity = quantityInputs[0];
        if (firstQuantity) {
          firstQuantity.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstQuantity.focus({ preventScroll: true });
        }
      });
    });
    populateGuidedStarter();
    if (guidedApply) guidedApply.addEventListener('click', function () {
      if (!guidedInputs.every(function (select) { return Boolean(select.value); })) return;
      var quantities = {};
      guidedInputs.forEach(function (select) { quantities[select.value] = (quantities[select.value] || 0) + 1; });
      applyQuantities(quantities, 'Selected starter applied.');
    });
    document.addEventListener('phq:builder-added', function(event) {
      if(root.getAttribute('data-surface')!=='builder'||!event.detail||!root.contains(event.detail.button)||encodeSelection(lastBuilderPlan)!==event.detail.selectionToken)return;
      selectionChangedAfterSuccess=true;
      resetInteractiveState();
      clearSelectionHistory(true);
      restoreMessage.hidden=true;
    });
    root.querySelector('[data-phq-v1711-clear]').addEventListener('click', function () {
      selectionChangedAfterSuccess = true;
      resetInteractiveState();
      clearSelectionHistory(false);
      restoreMessage.hidden = true;
      announce('Selection cleared.');
    });
    useBuilder.addEventListener('click', function () {
      if (!lastBuilderPlan.valid) return;
      selectionChangedAfterSuccess = true;
      clearMigration();
      builderCommitted = true;
      renderReview(lastBuilderPlan);
      writeSelectionHistory(lastBuilderPlan, false);
      announce('Build Your Own selection is ready to review.');
      review.scrollIntoView({ behavior: 'smooth', block: 'start' });
      reviewTitle.focus({ preventScroll: true });
    });
    }

    if (hasPlanner) {
    plannerForm.addEventListener('input', function () {
      if (currentPlanner || !plannerError.hidden) clearPlannerData('Planning details changed. Calculate again to update the result.', false, true);
    });
    plannerForm.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!plannerForm.checkValidity()) {
        plannerForm.reportValidity();
        return;
      }
      var result = calculatePlanner({
        people: plannerPeople.value,
        periodId: selectedRadioValue('phq_planning_period'),
        patternId: selectedRadioValue('phq_eating_pattern')
      });
      if (!result.valid) {
        showPlannerError(result.errors.join(' '), true);
        return;
      }
      renderPlanner(result, true);
      writePlannerHistory(result);
      closePlanEditor(true);
    });
    plannerClear.addEventListener('click', function () {
      plannerForm.reset();
      plannerBeforeEdit = null;
      clearPlannerData('', true, true);
    });
    // Constraint validation can prevent submit before its handler runs.
    plannerForm.addEventListener('invalid', function () {
      clearPlannerData('Review the planning details, then calculate again.', false, true);
    }, true);
    }

    if (planEdit) planEdit.addEventListener('click', function () {
      plannerBeforeEdit = currentPlanner;
      if (currentPlanner) setPlannerControls(currentPlanner);
      planEditor.hidden = false;
      planEdit.setAttribute('aria-expanded', 'true');
      if (plannerPeople) plannerPeople.focus();
    });
    if (planCancel) planCancel.addEventListener('click', function () {
      if (plannerBeforeEdit) {
        setPlannerControls(plannerBeforeEdit);
        renderPlanner(plannerBeforeEdit, true);
        writePlannerHistory(plannerBeforeEdit);
      } else clearPlannerData('', true, true);
      closePlanEditor(true);
    });
    if (planRemove) planRemove.addEventListener('click', function () {
      if (plannerForm) plannerForm.reset();
      clearPlannerData('Planning information removed. Your food selection is unchanged.', true, true);
      closePlanEditor(true);
    });

    if (contactForm) contactForm.addEventListener('submit', function (event) {
      if (currentMigration && !migrationAcknowledged) {
        event.preventDefault();
        announce('Review the updated pack before sending your enquiry.');
        if (migrationReview) migrationReview.focus();
        return;
      }
      if (planEditor && !planEditor.hidden) {
        event.preventDefault();
        if (plannerError) {
          plannerError.hidden = false;
          plannerError.textContent = 'Save or cancel your plan changes before sending your enquiry.';
        }
        if (plannerPeople) plannerPeople.focus();
        announcePlanner('Save or cancel your plan changes before sending your enquiry.');
        return;
      }
      syncPlannerFields();
      if (!currentSelection || !currentSelection.valid) {
        event.preventDefault();
        hideReview();
        restoreMessage.hidden = false;
        restoreMessage.focus && restoreMessage.focus();
      }
    });

    function recoverSelectionLocation() {
      var token = null;
      var migrationSource = null;
      var draftToken = null;
      try {
        var params = new URL(window.location.href).searchParams;
        token = params.getAll('phq').length > 1 ? 'invalid' : params.get('phq');
        migrationSource = params.getAll('phq_from').length === 1 ? params.get('phq_from') : null;
        draftToken = params.getAll('phq_draft').length > 1 ? 'invalid' : params.get('phq_draft');
      }
      catch (error) { token = null; }
      // Hash navigation and cached-page popstate must not reset unfinished choices.
      if (token === lastSelectionToken && migrationSource === lastMigrationSource && draftToken === lastDraftToken) return;
      lastSelectionToken = token;
      lastMigrationSource = migrationSource;
      lastDraftToken = draftToken;
      if (restoreMessage) restoreMessage.hidden = true;
      var recovery = deriveRecoveryState(catalogue, token);
      recoveringSelection = true;
      resetInteractiveState();
      recoveringSelection = false;
      if (draftToken !== null && hasBuilder) {
        var draft = token === null && migrationSource === null ? catalogue.parseBuilderDraft(draftToken) : null;
        if (!draft) {
          draftRecoveryFailed = true;
          if (restoreMessage) restoreMessage.hidden = false;
          try { window.sessionStorage.setItem('preparehq.builder-draft.v1', 'invalid'); } catch (error) { /* No storage required. */ }
          return;
        }
        var draftQuantities = {};
        draft.items.forEach(function (item) { draftQuantities[item.recipeId] = item.quantity; });
        applyQuantities(draftQuantities, 'Your recipe selection is ready to adjust.');
        return;
      }
      if (hasBuilder && recovery.state === 'clean') syncBuilderDraft();
      if (recovery.state === 'clean') return;
      if (recovery.state === 'invalid') {
        draftRecoveryFailed = true;
        if (hasBuilder) syncBuilderDraft();
        if (restoreMessage) restoreMessage.hidden = false;
        return;
      }
      if (recovery.state === 'migration') {
        renderMigration(recovery.migration, false);
        return;
      }
      var plan = recovery.plan;
      if (migrationSource && plan.kind === 'ready-made') {
        var acknowledgedMigration = migrationForSelection(catalogue, 'r.' + migrationSource);
        if (acknowledgedMigration && acknowledgedMigration.replacementId === plan.readyMadeId) renderMigration(acknowledgedMigration, true);
      }
      if (plan.kind === 'builder' && hasBuilder) {
        setQuantities(recovery.quantities);
        updateBuilder();
        builderCommitted = true;
      }
      renderReview(plan);
    }

    window.addEventListener('popstate', function () {
      closePlanEditor(false);
      recoverPlannerLocation(true, true);
      if (hasReview || migrationNotice) recoverSelectionLocation();
      reconcileHistoryInputs();
    });
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        closePlanEditor(false);
        recoverPlannerLocation(false, true);
      }
      if (event.persisted || isHistoryNavigation()) reconcileHistoryInputs();
    });
    // A normal saved link wins; Back/Forward instead follows the latest plan or removal in this tab.
    recoverPlannerLocation(false, isHistoryNavigation());
    if (serverFormSuccess) {
      // Preserve the saved planner, but do not restore an already-sent food selection.
      resetInteractiveState();
      clearSelectionHistory(true);
    } else if (hasReview || migrationNotice) recoverSelectionLocation();
    var formFeedback = root.querySelector('[data-phq-v1711-form-success], [data-phq-v1711-form-errors]');
    if (formFeedback) {
      formFeedback.scrollIntoView({ block: 'center' });
      formFeedback.focus({ preventScroll: true });
    }
    root.setAttribute('data-phq-v1711-ready', 'true');
    root.__phqV1714Catalogue = catalogue;
  }

  var api = {
    version: '1.9.11',
    validateCatalogue: validateCatalogue,
    ReserveCatalogue: ReserveCatalogue,
    createCatalogue: function (data) { return new ReserveCatalogue(data); },
    calculateReadyMade: function (data, readyMadeId) { return new ReserveCatalogue(data).readyMadePlan(readyMadeId); },
    calculateBuild: function (data, quantities) { return new ReserveCatalogue(data).calculateBuild(quantities); },
    resolveBuilderJourney: resolveBuilderJourney,
    calculatePricing: calculatePricing,
    deliveryForSelection: deliveryForSelection,
    savingDescription: savingDescription,
    legacyPackIds: LEGACY_PACK_IDS,
    encodeSelection: encodeSelection,
    encodeBuilderDraft: encodeBuilderDraft,
    parseSelection: function (data, token) { return new ReserveCatalogue(data).parseSelection(token); },
    deriveRecoveryState: function (data, token) { return deriveRecoveryState(new ReserveCatalogue(data), token); },
    selectionSummary: selectionSummary,
    builderCtaLabel: builderCtaLabel,
    builderAnnouncement: builderAnnouncement,
    formatMoney: formatMoney,
    plannerPeriods: PLANNER_PERIODS,
    plannerPeriodOrder: PLANNER_PERIOD_ORDER,
    plannerPatterns: PLANNER_PATTERNS,
    plannerPatternOrder: PLANNER_PATTERN_ORDER,
    calculatePlanner: calculatePlanner,
    plannerEquations: plannerEquations,
    plannerContext: plannerContext,
    plannerAnnouncement: plannerAnnouncement,
    encodePlannerState: encodePlannerState,
    parsePlannerState: parsePlannerState
  };

  if (typeof window !== 'undefined') window.PrepareHQV1714Reserve = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;

  function boot() { document.querySelectorAll('[data-phq-v1711-home]').forEach(initialise); }
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
    else boot();
  }
}());
